export default __webpack_public_path__ + "static/media/Rubik-ExtraBoldItalic.c5d6819a.woff2";